/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BucketValidatorDto } from '../../models/bucket-validator-dto';

export interface AdminControllerSetBucketValidatorLimit$Params {
  uuid: string;
  bucketUuid: string;
  limit: string;
}

export function adminControllerSetBucketValidatorLimit(http: HttpClient, rootUrl: string, params: AdminControllerSetBucketValidatorLimit$Params, context?: HttpContext): Observable<StrictHttpResponse<BucketValidatorDto>> {
  const rb = new RequestBuilder(rootUrl, adminControllerSetBucketValidatorLimit.PATH, 'put');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.path('bucketUuid', params.bucketUuid, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BucketValidatorDto>;
    })
  );
}

adminControllerSetBucketValidatorLimit.PATH = '/admin/user/{uuid}/bucket-validator/{bucketUuid}/set-limit';
